/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

var ApplicationConfiguration = /** @class */ (function () {
    function ApplicationConfiguration(raw) {
        this.application = raw.application;
    }
    return ApplicationConfiguration;
}());

var getRequest = function (method, url) {
    var requestObject = new XMLHttpRequest;
    requestObject.open(method, url, !0);
    // "undefined" != typeof XDomainRequest
    //   ? (requestObject = new XDomainRequest, requestObject.open(method, url))
    //   : requestObject = null;
    return requestObject;
};
var attachOnDoneCallbacks = function (requestObject, successCallback, errorCallback) {
    requestObject.onreadystatechange = function () {
        if (requestObject.readyState === XMLHttpRequest.DONE && 200 === requestObject.status) {
            if ("" === requestObject.responseType) {
                successCallback(requestObject.responseText);
            }
            else {
                successCallback(requestObject.response /* unsafe arg */);
            }
        }
        else if (requestObject.readyState === XMLHttpRequest.DONE) {
            if (errorCallback) {
                errorCallback(requestObject.response /* unsafe arg */);
            }
            else {
                console.log("error occurred with no errorCallback set.");
            }
        }
    };
    return requestObject;
};
var isBrowser = typeof window !== 'undefined' && typeof window.navigator !== 'undefined';
console.log('is browser:', isBrowser);
var useHttpsByUserAgent = isBrowser && /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
// navigator.userAgent.indexOf("Trident/7.0"); wow!
var API_LOCATION = "http://127.0.0.1:9100/";
if (useHttpsByUserAgent && "https:" === location.protocol) {
    API_LOCATION = "https://127.0.0.1:9101/";
}
var getApiLocation = function () { return API_LOCATION; };
var hasProperControlCharacters = function (characters) {
    if (2 !== characters.charCodeAt(0) || 3 !== characters.charCodeAt(characters.length - 1)) {
        console.log("Response did not contain proper control characters", characters);
        return false;
    }
    else {
        return true;
    }
};

// BrowserPrint here creates a circular ref, but it's needed unfortunately
/**
 * Represents a device. This object is passed to the client application to determine which device to communicate with.
 */
var Device = /** @class */ (function () {
    /**
     * A device is never instantiated directly, it is supplied by the native application.
     *
     * @param deviceJson Json describing this device
     */
    function Device(deviceJson) {
        var _this = this;
        /**
         * Function that is called if the errorCallback is not included for a send operation
         */
        this.sendErrorCallback = function () { };
        /**
         * Function that is called if a finishedCallback is not included for a send operation
         */
        this.sendFinishedCallback = function () { };
        /**
         * Function that is called if an errorCallback is not included for a read operation
         */
        this.readErrorCallback = function () { };
        /**
         * Function that is called if an finishedCallback is not included for a read operation
         */
        this.readFinishedCallback = function () { };
        /**
       * Same as attachDoneCallbacks except that it will attach default callback(s) when not specified
       */
        this.setupOnDoneCallbacks = function (requestObject, onSuccessCallback, onErrorCallback) {
            var success = (onSuccessCallback !== undefined)
                ? onSuccessCallback
                : BrowserPrint.defaultSuccessCallback;
            var failure = (onErrorCallback !== undefined)
                ? onErrorCallback
                : BrowserPrint.defaultErrorCallback;
            attachOnDoneCallbacks(requestObject, success, failure);
        };
        /**
         * Send data to the device
         *
         * @since Client API Level 2
         *
         * @param dataToSend The data to be sent to the device
         * @param onSuccessCallback The function that is called when sending is completed.
         * @param onErrorCallback The function that is called when an error occurs while sending.
         */
        this.send = function (dataToSend, onSuccessCallback, onErrorCallback) {
            var requestToSend = getRequest("POST", getApiLocation() + "write");
            if (undefined === onSuccessCallback) {
                onSuccessCallback = _this.sendFinishedCallback;
            }
            if (undefined === onErrorCallback) {
                onErrorCallback = _this.sendErrorCallback;
            }
            attachOnDoneCallbacks(requestToSend, onSuccessCallback, onErrorCallback);
            requestToSend.send(JSON.stringify({
                device: {
                    name: _this.name,
                    uid: _this.uid,
                    connection: _this.connection,
                    deviceType: _this.deviceType,
                    version: _this.version,
                    provider: _this.provider,
                    manufacturer: _this.manufacturer
                },
                data: dataToSend
            }));
        };
        /**
         * Same as send, but returns a promise.
         * @param dataToSend The data to be sent to the device
         * @returns let's see what it returns
         */
        this.sendAsync = function (dataToSend) {
            return new Promise(function (resolve, reject) {
                _this.send(dataToSend, function (responseText) { return resolve(responseText); }, function (error) { return reject(error); });
            });
        };
        /**
         * Send contents of url or blob to the device without any conversion.
         *
         * @since Client API Level 4
         *
         * @param resource The url from which data will be retrieved, or an already loaded blob, which will be sent to the device
         * @param onSuccessCallback The function that is called when sending is completed.
         * @param onErrorCallback The function that is called when an error occurs while sending.
         */
        this.sendFile = function (resource, onSuccessCallback, onErrorCallback) {
            if ("string" === typeof resource) {
                var onFileLoadedCallback = function (newData) {
                    _this.sendFile(newData !== null && newData !== void 0 ? newData : '' /* coersion for Typescript */, onSuccessCallback, onErrorCallback);
                };
                BrowserPrint.loadFileFromUrl(resource /* original code shadowed this variable */, onFileLoadedCallback, onErrorCallback);
            }
            else {
                var requestObject = getRequest("POST", getApiLocation() + "write");
                if (requestObject) {
                    requestObject.responseType = "text";
                    _this.setupOnDoneCallbacks(requestObject, onSuccessCallback, onErrorCallback);
                    var formData = new FormData;
                    var jsonPayload = {
                        device: _this // woah weird.  probably we want
                    };
                    formData.append("json", JSON.stringify(jsonPayload));
                    formData.append("blob", resource);
                    requestObject.send(formData);
                }
            }
        };
        /**
         * Read data from the device
         *
         * @since Client API Level 2
         *
         * @param finishedCallback The function that is called when reading is completed, passing in the data read.
         * @param errorCallback The function that is called when an error occurs while reading, passing in the error message if there is one.
         */
        this.read = function (finishedCallback, errorCallback) {
            var requestObject = getRequest("POST", getApiLocation() + "read");
            if (undefined === finishedCallback) {
                finishedCallback = _this.readFinishedCallback;
            }
            if (undefined === errorCallback) {
                errorCallback = _this.readErrorCallback;
            }
            attachOnDoneCallbacks(requestObject, finishedCallback, errorCallback);
            requestObject.send(JSON.stringify({
                device: {
                    name: _this.name,
                    uid: _this.uid,
                    connection: _this.connection,
                    deviceType: _this.deviceType,
                    version: _this.version,
                    provider: _this.provider,
                    manufacturer: _this.manufacturer
                }
            }));
        };
        /**
         * Read data from the device until a specific string is received, or the read response is empty
         *
         * @since Client API Level 2
         *
         * @param receivedString The String that must be received before the finishedCallback is called.
         * @param finishedCallback The function that is called when reading is completed, passing in the data read.
         * @param errorCallback The function that is called when an error occurs while reading, passing in the error message if there is one.
         * @param retries The number of reads to attempt before receiving any data. Once any amount of data is received, no retries will be made. If this value is undefined, the value of the readRetries property will be used.
         * @param c ??? not listed in jsdoc
         */
        this.readUntilStringReceived = function (receivedString, finishedCallback, errorCallback, retries, c) {
            if (!c) {
                c = "";
            }
            if (undefined === retries) {
                retries = _this.readRetries;
            }
            // TODO: clean this up with arrow function.
            finishedCallback = function (device, finishedCallbackInner, e, retries, accumulatedText) {
                return function (c) {
                    if (c && 0 !== c.length) {
                        retries = 0;
                    }
                    else if (0 >= retries) {
                        finishedCallbackInner(accumulatedText);
                        return;
                    }
                    c = accumulatedText + c;
                    if ("" !== receivedString && -1 < c.indexOf(receivedString)) {
                        finishedCallbackInner(c);
                    }
                    else {
                        device.readUntilStringReceived(receivedString, finishedCallbackInner, e, retries - 1, c);
                    }
                };
            }(_this, finishedCallback !== null && finishedCallback !== void 0 ? finishedCallback : BrowserPrint.defaultSuccessCallback /* to not need null assertion */, errorCallback, retries, c);
            _this.read(finishedCallback, errorCallback);
        };
        /**
         * Read data from the device until a read completes with no data returned.
         *
         * @since Client API Level 2
         *
         * @param finishedCallback The function that is called when reading is completed, passing in the data read.
         * @param errorCallback The function that is called when an error occurs while reading, passing in the error message if there is one.
         * @param retries The number of reads to attempt before receiving any data. Once any amount of data is received, no retries will be made. If this value is undefined, the value of the readRetries property will be used.
         */
        this.readAllAvailable = function (finishedCallback, errorCallback, retries) {
            _this.readUntilStringReceived("", finishedCallback, errorCallback, retries);
        };
        /**
         * Send data to the device, then read a response back
         *
         * @since Client API Level 2
         *
         * @param dataToSend
         * @param finishedCallback
         * @param errorCallback
         */
        this.sendThenRead = function (dataToSend, finishedCallback, errorCallback) {
            _this.send(dataToSend, function (text) {
                console.log('send received:', text);
                _this.read(finishedCallback, errorCallback);
            }, errorCallback);
        };
        /**
         * Send data to the device, then read a response back until the specified string is received or all data has been read
         *
         * @since Client API Level 2
         *
         * @param dataToSend The data to be sent to the device
         * @param receivedString The string that must be received before the finishedCallback is called.
         * @param finishedCallback The function that is called when reading is completed.
         * @param errorCallback The function that is called when an error occurs while sending or reading data.
         * @param retries The number of reads to attempt before receiving any data. Once any amount of data is received, no retries will be made. If this value is undefined, the value of the readRetries property will be used.
         */
        this.sendThenReadUntilStringReceived = function (dataToSend, receivedString, finishedCallback, errorCallback, retries) {
            _this.send(dataToSend, function (text) {
                console.log('text received', text);
                _this.readUntilStringReceived(receivedString, finishedCallback, errorCallback, retries);
            }, errorCallback);
        };
        /**
         * Send data to the device, then read a response back until the specified string is received or all data has been read
         *
         * @since Client API Level 2
         *
         * @param dataToSend The data to be sent to the device
         * @param finishedCallback The function that is called when reading is completed.
         * @param errorCallback The function that is called when an error occurs while sending or reading data.
         * @param retries The number of reads to attempt before receiving any data. Once any amount of data is received, no retries will be made. If this value is undefined, the value of the readRetries property will be used.
         */
        this.sendThenReadAllAvailable = function (dataToSend, finishedCallback, errorCallback, retries) {
            _this.send(dataToSend, function (responseText) {
                console.log('send received text:', responseText);
                _this.readUntilStringReceived("", finishedCallback, errorCallback, retries);
            }, errorCallback);
        };
        /**
         * Send contents of url or blob to the device. If the url points to an image file (bmp, jpg, png, tif, gif) or PDF, it will automatically be converted to a printer command language. This method is a wrapper for BrowserPrint.convert
         *
         * @since Client API Level 4
         *
         * @param resource The url from which data will be retrieved and be sent to the device
         * @param finishedCallback The function that is called when sending is completed.
         * @param errorCallback The function that is called when an error occurs while sending.
         * @param options Options for converting the file.
         */
        this.convertAndSendFile = function (resource, finishedCallback, errorCallback, options) {
            if (!options) {
                options = {};
            }
            if (!options.action) {
                options.action = "print";
            }
            // TODO: need to delegate to browserprint - is it a static method or do we need instance?
            BrowserPrint.convert(resource, _this, options, finishedCallback, errorCallback);
        };
        /**
          * Send contents of url to the device. If the url points to an image file (bmp, jpg, png, tif, gif) or PDF, it will automatically be converted to a printer command language.
          *
          * @since Client API Level 2
          * @deprecated This method has been deprecated as of version 3.0.0 and will be removed in the future. Please reference convertAndSendFile for a replacement method.
          *
          * @param url The url from which data will be retrieved and be sent to the device
          * @param onSuccessCallback The function that is called when sending is completed.
          * @param onErrorCallback The function that is called when an error occurs while sending.
          * @param options Options for converting the file at the url being sent.
          */
        this.sendUrl = function (url, onSuccessCallback, onErrorCallback, options) {
            var requestObject = getRequest("POST", getApiLocation() + "write");
            _this.setupOnDoneCallbacks(requestObject, onSuccessCallback, onErrorCallback);
            var data = {
                device: {
                    name: _this.name,
                    uid: _this.uid,
                    connection: _this.connection,
                    deviceType: _this.deviceType,
                    version: _this.version,
                    provider: _this.provider,
                    manufacturer: _this.manufacturer
                },
                url: url
            };
            if (null != options && undefined != options) {
                data.options = options;
            }
            requestObject.send(JSON.stringify(data));
        };
        // TODO: back more properties to private (name, connection, version, readRetries)
        this.uid = deviceJson.uid;
        this.name = deviceJson.name;
        this.connection = deviceJson.connection;
        this.deviceType = deviceJson.deviceType;
        this.provider = deviceJson.provider;
        this.manufacturer = deviceJson.manufacturer;
        this.version = deviceJson.version;
        // not provided by device
        this.readRetries = ("bluetooth" === this.connection) ? 1 : 0;
    }
    return Device;
}());

// TODO: remove this
/* eslint-disable */
var deviceTimeoutMap = {};
var ToFormat;
(function (ToFormat) {
    ToFormat["zpl"] = "zpl";
    ToFormat["cpcl"] = "cpcl";
    ToFormat["kpl"] = "kpl";
    ToFormat["none"] = "none";
})(ToFormat || (ToFormat = {}));
var BrowserPrint = /** @class */ (function () {
    function BrowserPrint() {
    }
    var _a;
    _a = BrowserPrint;
    /**
     * Function that is called if the successCallback is not included for a BrowserPrint operation.
     *
     * @param response success response on callback
     */
    BrowserPrint.defaultSuccessCallback = function () { };
    /**
     * Function that is called if the errorCallback is not included for a BrowserPrint operation.
     *
     * @param response error response on callback
     */
    BrowserPrint.defaultErrorCallback = function () { };
    BrowserPrint.loadFileFromUrl = function (url, onSuccessCallback, onErrorCallback) {
        var request = getRequest("get", url);
        console.log("ResponseType: " + request.responseType);
        request.responseType = "blob";
        setupOnDoneCallbacks(request, onSuccessCallback, onErrorCallback);
        request.send();
    };
    BrowserPrint.convert = function (data, device, options, onSuccessCallback, onErrorCallback) {
        if (data) {
            if ("string" === typeof data) {
                var successCallback = function (responseText) {
                    if (!options.fromFormat) {
                        options.fromFormat = data.substring(data.length - 3);
                    }
                    var textToConvert = (responseText === null) ? undefined : responseText; // to narrow type for 'convert'
                    _a.convert(textToConvert, device, options, onSuccessCallback, onErrorCallback);
                };
                _a.loadFileFromUrl(data, successCallback, onErrorCallback);
            }
            else {
                var requestObject = getRequest("POST", getApiLocation() + "convert");
                if (data.type && (data.type.startsWith("image/") || data.type.startsWith("application/"))) {
                    options.fromFormat = data.type.toLowerCase().replace("image/", "").replace("application/", "").replace("x-ms-", "");
                }
                if (requestObject) {
                    requestObject.responseType = "text";
                    setupOnDoneCallbacks(requestObject, function (successResponseText) { onSuccessCallback(JSON.parse(successResponseText !== null && successResponseText !== void 0 ? successResponseText : '' /* coersion for typescript */)); }, onErrorCallback);
                    var formData = new FormData;
                    var jsonPayload = {};
                    if (null != options && undefined !== options) {
                        jsonPayload.options = options;
                    }
                    if (device) {
                        jsonPayload.device = device;
                    }
                    formData.append("json", JSON.stringify(jsonPayload));
                    formData.append("blob", data);
                    requestObject.send(formData);
                }
            }
        }
        else {
            if (onErrorCallback) {
                onErrorCallback("Resource not specified");
            }
            else {
                BrowserPrint.defaultErrorCallback("Resource not specified");
            }
        }
    };
    /**
     * Get devices available to the local client
     *
     * @since Client API Level 2
     *
     * @param finishedCallback The function that is called when finding devices is completed, passing an array of devices to the function.
     * @param errorCallback The function that is called if an error occurs while finding devices, passing the error message to the function if there is one.
     * @param typeFilter The type of device you are looking for. Not specifying a type will return all devices.
     */
    BrowserPrint.getLocalDevices = function (finishedCallback, errorCallback, typeFilter) {
        var requestObject = getRequest("GET", getApiLocation() + "available");
        var finishedFunction = function (finishedResponseText) {
            var response = JSON.parse(finishedResponseText);
            var result = {};
            for (var c in response)
                if (response.hasOwnProperty(c) && Array.isArray(response[c])) {
                    var deviceFieldsList = response[c];
                    result[c] = [];
                    for (var _i = 0, deviceFieldsList_1 = deviceFieldsList; _i < deviceFieldsList_1.length; _i++) {
                        var deviceFields = deviceFieldsList_1[_i];
                        result[c].push(new Device(deviceFields));
                    }
                }
            if (undefined === typeFilter) {
                finishedCallback(result);
            }
            else {
                if (!response.hasOwnProperty(typeFilter)) {
                    response[typeFilter] = [];
                }
                finishedCallback(result[typeFilter]);
            }
        };
        setupOnDoneCallbacks(requestObject, finishedFunction, errorCallback);
        requestObject.send();
    };
    BrowserPrint.getLocalDevicesAsync = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _this = _a;
        return __generator(_a, function (_b) {
            return [2 /*return*/, new Promise(function (resolve, reject) {
                    _this.getLocalDevices(function (discoveredDevices) { return resolve(discoveredDevices); }, function (error) { return reject(error); });
                })];
        });
    }); };
    BrowserPrint.getDefaultDevice = function (deviceType, successCallback, errorCallback) {
        var apiPath = "default";
        if (undefined !== deviceType) {
            apiPath = apiPath + "?type=" + deviceType;
        }
        var requestObject = getRequest("GET", getApiLocation() + apiPath);
        var finishedFunction = function (successResponseText) {
            var response = successResponseText;
            if ("" === response || response === undefined || response === null) {
                successCallback(null);
            }
            else {
                var device = new Device(JSON.parse(response));
                successCallback(device);
            }
        };
        requestObject = setupOnDoneCallbacks(requestObject, finishedFunction, errorCallback);
        requestObject.send();
    };
    BrowserPrint.getDefaultDeviceAsync = function (deviceType) { return __awaiter(void 0, void 0, void 0, function () {
        var _this = _a;
        return __generator(_a, function (_b) {
            return [2 /*return*/, new Promise(function (resolve, reject) {
                    _this.getDefaultDevice(deviceType, function (device) { return resolve(device); }, function (error) { return reject(error); });
                })];
        });
    }); };
    BrowserPrint.getApplicationConfiguration = function (successCallback, errorCallback) {
        var requestObject = getRequest("GET", getApiLocation() + "config");
        var finishedFunction = function (successResponseText) {
            var response = successResponseText;
            if ("" === response || response === undefined || response === null) {
                successCallback(null);
            }
            else {
                var applicationConguration = JSON.parse(response);
                successCallback(new ApplicationConfiguration(applicationConguration));
            }
        };
        setupOnDoneCallbacks(requestObject, finishedFunction, errorCallback);
        requestObject.send();
    };
    BrowserPrint.getApplicationConfigurationAsync = function () {
        return new Promise(function (resolve, reject) {
            _a.getApplicationConfiguration(function (applicationConfiguration) { return resolve(applicationConfiguration); }, function (error) { return reject(error); });
        });
    };
    BrowserPrint.readOnInterval = function (device, callback, readInterval) {
        if (undefined === readInterval || 0 === readInterval) {
            readInterval = 1;
        }
        var readFunc = function () {
            device.read(function (c) {
                callback(c);
                deviceTimeoutMap[device] = setTimeout(readFunc, readInterval);
            }, function (b) {
                deviceTimeoutMap[device] = setTimeout(readFunc, readInterval);
            });
        };
        deviceTimeoutMap[device] = setTimeout(readFunc, readInterval);
    };
    /**
     * Stops continually reading from a device that was registered with readOnInterval or bindFieldToReadData
     * @param device
     */
    BrowserPrint.stopReadOnInterval = function (device) {
        if (deviceTimeoutMap[device]) {
            clearTimeout(deviceTimeoutMap[device]);
        }
    };
    BrowserPrint.bindFieldToReadData = function (device, field, readInterval, onReadCallback) {
        var onIntervalCallback = function (responseText) {
            if ("" !== responseText) {
                field.value = responseText;
                if (undefined !== onReadCallback && null != onReadCallback) {
                    onReadCallback();
                }
            }
        };
        _a.readOnInterval(device, onIntervalCallback, readInterval);
    };
    return BrowserPrint;
}());
var setupOnDoneCallbacks = function (requestObject, successCallback, onErrorCallback) {
    if (undefined === successCallback) {
        successCallback = BrowserPrint.defaultSuccessCallback;
    }
    if (undefined === onErrorCallback) {
        onErrorCallback = BrowserPrint.defaultErrorCallback;
    }
    return attachOnDoneCallbacks(requestObject, successCallback, onErrorCallback);
};

var Configuration = /** @class */ (function () {
    function Configuration(raw) {
        if (!raw)
            throw "Invalid Response";
        this.raw = raw = raw.trim();
        this._settings = {};
        if (!hasProperControlCharacters(raw)) {
            throw "Invalid Response";
        }
        raw = raw.replace(String.fromCharCode(2), "");
        raw = raw.replace(String.fromCharCode(3), "");
        var parts = raw.split("\n");
        for (var f = 0; f < parts.length; ++f) {
            var b = parts[f].trim();
            var d = b.substring(20);
            b = b.substring(0, 20).trim();
            this._settings[d] = b;
        }
        this._darkness = parseFloat(this._settings.DARKNESS);
        this._printSpeed = parseInt(this._settings["PRINT SPEED"].replace("IPS", "").trim());
        this._printWidth = parseInt(this._settings["PRINT WIDTH"]);
        this._labelLength = parseInt(this._settings["LABEL LENGTH"]);
        this._firmwareVersion = this._settings.FIRMWARE.replace("<-", "").trim();
        this._linkOSVersion = this._settings.hasOwnProperty("LINK-OS VERSION") ? this._settings["LINK-OS VERSION"] : "0";
    }
    Object.defineProperty(Configuration.prototype, "darkness", {
        /**
         * The darkness value as a float
         */
        get: function () {
            return this._darkness;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Configuration.prototype, "printSpeed", {
        /**
         * The print speed in dots per inch (int)
         */
        get: function () {
            return this._printSpeed;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Configuration.prototype, "printWidth", {
        /**
         * The width in dots (int)
         */
        get: function () {
            return this._printWidth;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Configuration.prototype, "labelLength", {
        /**
         * The current label length (int)
         */
        get: function () {
            return this._labelLength;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Configuration.prototype, "firmwareVersion", {
        /**
         * The version of firmware running on the printer
         */
        get: function () {
            return this._firmwareVersion;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Configuration.prototype, "linkOSVersion", {
        /**
         * The version of Link-OS the printer is running, or "0" if the printer is not a Link-OS Printer
         */
        get: function () {
            return this._linkOSVersion;
        },
        enumerable: false,
        configurable: true
    });
    return Configuration;
}());

/**
 * Represents information about the Zebra Printer
 *
 * @since Client API Level 2
 */
var Info = /** @class */ (function () {
    /**
     *
     * @param raw The information response from the printer to be parsed
     */
    function Info(raw) {
        if (!raw) {
            throw "Invalid Response";
        }
        this.raw = raw;
        raw = raw.trim();
        if (!hasProperControlCharacters(raw)) {
            throw "Invalid Response";
        }
        var parts = raw.split(","); // TODO: verify length?
        this._model = parts[0].substring(1);
        this._firmware = parts[1];
    }
    Object.defineProperty(Info.prototype, "firmware", {
        /**
         * The printer firmware version
         */
        get: function () {
            return this._firmware;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Info.prototype, "model", {
        /**
         * The printer model
         */
        get: function () {
            return this._model;
        },
        enumerable: false,
        configurable: true
    });
    return Info;
}());

var Status = /** @class */ (function () {
    function Status(raw) {
        var _this = this;
        this.isFlagSet = function (index) {
            return "1" === _this.raw.charAt(index);
        };
        /**
         * Returns whether the printer is ready to print or not.
         * @returns True if the printer is ready to print, false otherwise
         */
        this.isPrinterReady = function () {
            return !(_this._paperOut || _this._paused || _this._headOpen || _this._ribbonOut || _this._offline);
        };
        /**
         * Returns a string describing the state of the printer in english.
         *
         * @returns The description of the status in english
         */
        this.getMessage = function () {
            return _this.isPrinterReady() ? "Ready" : _this._offline ? "Offline" : _this._paperOut ? "Paper Out" : _this._headOpen ? "Head Open" : _this._ribbonOut ? "Ribbon Out" : _this._paused ? "Paused" : "Ready";
        };
        if (!raw) {
            raw = "";
        }
        raw = raw.trim();
        this.raw = raw;
        this._offline = false;
        if (hasProperControlCharacters(raw)) {
            this._offline = false;
            this._paperOut = this.isFlagSet(5);
            this._paused = this.isFlagSet(7);
            this._headOpen = this.isFlagSet(43);
            this._ribbonOut = this.isFlagSet(45);
        }
        else {
            this._offline = true;
            this._ribbonOut = false;
            this._headOpen = false;
            this._paused = false;
            this._paperOut = false;
        }
    }
    Object.defineProperty(Status.prototype, "offline", {
        /**
         * Not in JsDoc, but referenced elsewhere
         */
        get: function () {
            return this._offline;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Status.prototype, "paperOut", {
        /**
         * True if the printer is in a paper out state, false otherwise
         */
        get: function () {
            return this._paperOut;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Status.prototype, "paused", {
        /**
         * True if the printer is in a paused state, false otherwise
         */
        get: function () {
            return this._paused;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Status.prototype, "headOpen", {
        /**
         * True if the printer is in a head open state, false otherwise
         */
        get: function () {
            return this._headOpen;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Status.prototype, "ribbonOut", {
        /**
         * True if the printer is in a ribbon out state, false otherwise
         */
        get: function () {
            return this._ribbonOut;
        },
        enumerable: false,
        configurable: true
    });
    return Status;
}());

var dbg = function (msg) {
    console.log(msg);
};
/**
 * Responsible for certain request types to continue reading until the 0x03 (end text code) is received.
 * Waiting for that character ensures the entire message is ready to be parsed
 *
 * @hidden
 */
var Request = /** @class */ (function () {
    function Request(printer, device, type, command, received, success, errorCallback) {
        var _this = this;
        this.started = false;
        this.error = function (err) {
            // was immediately invoked function returning a function to get "this" via closure
            // this.error = function (a) {
            //   return function (f) {
            //      a(f);
            //       d.executeNextRequest() 
            //   }
            // }(e); // where "e" is is the error callback?
            _this._errorCallback(err);
            _this._printer.executeNextRequest();
        };
        this.execute = function () {
            _this.started = true;
            console.log("executing '".concat(_this.type, "' with command: '").concat(_this.command, "'"));
            if ("info" == _this.type || "config" == _this.type || "status" == _this.type) {
                _this._device.sendThenReadUntilStringReceived(_this.command, String.fromCharCode(3), _this.received, _this.error);
            }
            else {
                _this._device.sendThenReadAllAvailable(_this.command, _this.received, _this.error);
            }
        };
        this.type = type;
        this.command = command;
        this.received = received;
        this.success = success;
        this._printer = printer;
        this._device = device;
        this._errorCallback = errorCallback;
    }
    Object.defineProperty(Request.prototype, "device", {
        get: function () {
            return this._device;
        },
        enumerable: false,
        configurable: true
    });
    return Request;
}());
var Printer = /** @class */ (function () {
    function Printer(device) {
        var _this = this;
        this._configRetries = 0;
        /**
         * @hidden It's called by request to progress the queue, but otherwise should not be "internal".
         */
        this.executeNextRequest = function () {
            _this.device_request_queue.shift();
            _this.executeRequest();
        };
        this.executeRequest = function () {
            // dbg("Requests in queue: " + this.device_request_queue.length);
            if (0 < _this.device_request_queue.length) {
                dbg("Executing next request...");
                _this.device_request_queue[0].execute();
            }
        };
        this.queueRequest = function (request) {
            dbg("Queueing request " + request.type + ": " + _this.device_request_queue.length);
            _this.device_request_queue.push(request);
            if (1 === _this.device_request_queue.length) {
                request.execute();
            }
        };
        /**
         * NOTE: this is from unminified source
         */
        this.onStatusResponse = function (responseText) {
            dbg("received status response");
            var newStatus = undefined;
            try {
                newStatus = new Status(responseText !== null && responseText !== void 0 ? responseText : '');
            }
            catch (error) {
                var currentRequest = _this.device_request_queue[0];
                currentRequest.error(error);
                _this.executeNextRequest();
            }
            for (; 0 < _this.device_request_queue.length;) {
                var request = _this.device_request_queue[0];
                if ("status" === request.type) {
                    dbg("delivering status...");
                    request.success(newStatus);
                    _this.device_request_queue.shift();
                }
                else {
                    dbg("delivered to all status requests.");
                    break;
                }
                _this.executeRequest();
            }
        };
        this.onResponse = function (responseText, classType) {
            dbg("received info response");
            var currentRequest = _this.device_request_queue[0];
            var result = undefined;
            if (undefined != classType) {
                // this branch is not part of original library. added for compiling
                if (responseText === undefined || responseText === null) {
                    if (currentRequest.error) {
                        currentRequest.error('response text null or undefined?');
                    }
                    _this.executeNextRequest();
                    return;
                }
                try {
                    result = new classType(responseText);
                }
                catch (err) {
                    if (currentRequest.error) {
                        currentRequest.error(err);
                    }
                    _this.executeNextRequest();
                    return;
                }
            }
            currentRequest.success && currentRequest.success(result);
            _this.executeNextRequest();
        };
        this.onSGDResponse = function (responseText) {
            dbg("received sgd response");
            _this.onResponse(responseText);
        };
        this.onInfoResponse = function (responseText) {
            dbg("received info response");
            _this.onResponse(responseText, Info);
        };
        this.onConfigurationResponse = function (responseText) {
            dbg("received config response");
            // this brach was added for typing errors
            if (responseText === null || responseText === undefined) {
                console.error('this should not happen');
                _this.onResponse('', Configuration);
                return;
            }
            try {
                _this.configuration = new Configuration(responseText);
            }
            catch (f) {
                // was empty catch in original library
                console.error('cannot parse configuration', responseText);
            }
            _this.onResponse(responseText, Configuration);
        };
        /**
         * Clears all remaining requests in the queue. This does not cancel the currently running request
         */
        this.clearRequestQueue = function () {
            var currentRequest = _this.device_request_queue[0];
            _this.device_request_queue = [];
            if (currentRequest && currentRequest.started) {
                // put it back on the queue - it's still running
                _this.device_request_queue[0] = currentRequest;
            }
        };
        /**
         * Queued
         *
         * Sets an 'SGD' settings value on the printer. This query to the printer is synchronized so that the last query response is received before this query is sent. This means all synchronized queries will be sent and received in the order they are called.
         * @param setting The setting to set the value of
         * @param value The value the setting should be set to
         * @param success A callback function on success. Omitting the success and failure callbacks will automatically setup a Promise instead
         * @param failure A callback function on failure. Omitting the success and failure callbacks will automatically setup a Promise instead
         * @returns If no callback functions are supplied, returns a Promise that resolve when setting the value has completed. Otherwise returns nothing
         */
        this.setSGD = function (setting, value, success, failure) {
            if (!success && !failure)
                return new Promise(function (b, c) {
                    this.setSGD(setting, value, b, c);
                });
            _this.device.send('! U1 setvar "' + setting + '" "' + value + '"\r\n', success, failure);
        };
        /**
         * Queued
         *
         * Get the value of an 'SGD' setting. This query to the printer is synchronized so that the last query response is received before this query is sent. This means all synchronized queries will be sent and received in the order they are called.
         * @param setting The 'SGD' setting to retrieve
         * @param success A callback function on success, which has the value of the setting passed to it. Omitting the success and failure callbacks will automatically setup a Promise instead
         * @param failure A callback function on failure. Omitting the success and failure callbacks will automatically setup a Promise instead
         * @returns If no callback functions are supplied, returns a Promise that will output the completed printer command. Otherwise returns nothing.
         */
        this.getSGD = function (setting, success, failure) {
            if (!success && !failure) {
                return new Promise(function (resolve, reject) {
                    _this.getSGD(setting, resolve /* NOTE: this is not a good cast */, reject);
                });
            }
            // added as it was a convention to call both or none, but broke type safety
            if (!success || !failure) {
                throw new Error('called with missing only one of success or failure handlers');
            }
            var request = new Request(_this, _this.device, "sgd", '! U1 getvar "' + setting + '"\r\n', _this.onSGDResponse, success, failure);
            _this.queueRequest(request);
        };
        /**
         * Queued
         *
         * Set, then Get the value of an 'SGD' setting. This query to the printer is synchronized so that the last query response is received before this query is sent. This means all synchronized queries will be sent and received in the order they are called.
         * @param setting The 'SGD' setting to to set and then retrieve
         * @param value The value to set the 'SGD' setting to
         * @param success A callback function on success, which has the value of the setting passed to it. Omitting the success and failure callbacks will automatically setup a Promise instead
         * @param failure A callback function on failure. Omitting the success and failure callbacks will automatically setup a Promise instead
         * @returns If no callback functions are supplied, returns a Promise that will output the completed printer command. Otherwise returns nothing.
         */
        this.setThenGetSGD = function (setting, value, success, failure) {
            if (!success && !failure) {
                return new Promise(function (f, c) {
                    this.setThenGetSGD(setting, value, f, c);
                });
            }
            _this.setSGD(setting, value, function () {
                _this.getSGD(setting, success, failure);
            }, failure);
        };
        this.getInfo = function (success, failure) {
            if (!success && !failure)
                return new Promise(function (a, b) {
                    this.getInfo(a, b);
                });
            // added as it was a convention to call both or none, but broke type safety
            if (!success || !failure) {
                throw new Error('called with missing only one of success or failure handlers');
            }
            var request = new Request(_this, _this.device, "info", "~hi\r\n", _this.onInfoResponse, success, failure);
            _this.queueRequest(request);
        };
        /**
         * Queued
         *
         * Sends a request to the printer, then builds and returns Zebra.Printer.Configuration object from the response. This query to the printer is synchronized so that the last query response is received before this query is sent. This means all synchronized queries will be sent and received in the order they are called.
         *
         * @since Client API Level 2
         *
         * @param success A callback function on success, which has the Zebra.Printer.Configuration object passed to it. Omitting the success and failure callbacks will automatically setup a Promise instead
         * @param failure A callback function on failure, which has the error message passed to it as a string. Omitting the success and failure callbacks will automatically setup a Promise instead
         * @returns
         */
        this.getConfiguration = function (success, failure) {
            if (!success && !failure) {
                return new Promise(function (resolve, reject) {
                    _this.getConfiguration(resolve, reject);
                });
            }
            // added as it was a convention to call both or none, but broke type safety
            if (!success || !failure) {
                throw new Error('called with missing only one of success or failure handlers');
            }
            var request = new Request(_this, _this.device, "config", "^XA^HH^XZ", _this.onConfigurationResponse, success /* TODO: check if this is safe */, failure);
            _this.queueRequest(request);
        };
        /**
         * Queued
         *
         * Sends a request to the printer, then builds and returns a Zebra.Printer.Status object from response. This query to the printer is synchronized so that the last query response is received before this query is sent. This means all synchronized queries will be sent and received in the order they are called.
         *
         * @param success A callback function on success, which has the Zebra.Printer.Status object passed to it. Omitting the success and failure callbacks will automatically setup a Promise instead
         * @param failure A callback function on failure, which has the error message passed to it as a string. Omitting the success and failure callbacks will automatically setup a Promise instead
         * @returns
         */
        this.getStatus = function (success, failure) {
            if (!success && !failure) {
                return new Promise(function (resolve, reject) {
                    _this.getStatus(resolve, reject);
                });
            }
            // added as it was a convention to call both or none, but broke type safety
            if (!success || !failure) {
                throw new Error('called with missing failure xor success handler');
            }
            // decompiled had "~hs\r\n"
            var request = new Request(_this, _this.device, "status", "~HQES", _this.onStatusResponse, success /* TODO: check if this is safe */, failure);
            _this.queueRequest(request);
        };
        this.getStatusAsync = function () { return __awaiter(_this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        _this.getStatus(function (status) {
                            resolve(status);
                        }, function (error) {
                            reject(error);
                        });
                    })];
            });
        }); };
        /**
         * Queued
         *
         * Sends a command to the printer, then reads back the response. This query to the printer is synchronized so that the last query response is received before this query is sent. This means all synchronized queries will be sent and received in the order they are called.
         * @param command The query command to send to the printer
         * @param success A callback function on success, which has the Zebra.Printer.Status object passed to it. Omitting the success and failure callbacks will automatically setup a Promise instead
         * @param failure A callback function on failure, which has the error message passed to it as a string. Omitting the success and failure callbacks will automatically setup a Promise instead
         * @returns If no callback functions are supplied, returns a Promise that will return the Zebra.Printer.Status object. Otherwise returns nothing.
         */
        this.query = function (command, success, failure) {
            if (!success && !failure) {
                return new Promise(function (b, c) {
                    this.query(command, b, c);
                });
            }
            var request = new Request(_this, _this.device, "", command, _this.onResponse, success, failure);
            _this.queueRequest(request);
        };
        /**
         * Checks and reports whether the printer is ready to print.
         *
         * @since Client API Level 2
         *
         * @param success A callback function called if the printer is ready to print, passing the status message. Omitting the success and failure callbacks will automatically setup a Promise instead
         * @param failure A callback function called if the printer is not ready to print, passing the error message, which has the error message passed to it as a string. Omitting the success and failure callbacks will automatically setup a Promise instead
         * @returns If no callback functions are supplied, returns a Promise object. Otherwise returns nothing.
         */
        this.isPrinterReady = function (success, failure) {
            if (!success && !failure) {
                return new Promise(function (a, b) {
                    this.isPrinterReady(a, b);
                });
            }
            // added as it was a convention to call both or none, but broke type safety
            if (!success || !failure) {
                throw new Error('called with missing failure handler or success handler');
            }
            _this.getStatus().then(function (c) {
                if (c.isPrinterReady()) {
                    success(c.getMessage());
                }
                else {
                    failure(c.getMessage());
                }
            });
        };
        /**
         * Prints an image resource as a label, automatically resizing the image to best fill the print width and label length. Image will be scaled to the largest possible size while still entirely fitting within the printable area of the label, according to the Zebra.Printer.Configuration retrieved from the printer. This function requires that the API has successfully retrieved the printer configuration before calling.
         *
         * @since Client API Level 4
         *
         * @param resource The resource to be printed. Accepts a URL as a string, or a blob of an already loaded image file.
         * @param options Options for converting the resource.
         * @param success A callback function on success. Omitting the success and failure callbacks will automatically setup a Promise instead
         * @param failure A callback function on failure, which has the error message passed to it as a string. Omitting the success and failure callbacks will automatically setup a Promise instead
         * @returns If no callback functions are supplied, returns a Promise object. Otherwise returns nothing.
         */
        this.printImageAsLabel = function (resource, options, success, failure) {
            if (!success && !failure) {
                return new Promise(function (resolve, reject) {
                    _this.printImageAsLabel(resource, options, resolve, reject);
                });
            }
            // added as it was a convention to call both or none, but broke type safety
            if (!success || !failure) {
                throw new Error('called with missing only one of success or failure handlers');
            }
            _this.getConfigurationRetrieveIfNeeded().then(function (b) {
                options.fitTo = {
                    width: b.printWidth,
                    height: b.labelLength
                };
                options.action = "print";
                BrowserPrint.convert(resource, this.device, options, success, failure);
            }).catch(failure);
        };
        /**
         * Retrieves the resource and converts it into a printable form. Converted resource will be returned as string with a format dependent on printer command language requested and capabilities of the host platform.
         *
         * @since Client API Level 4
         *
         * @param resource The resource to be printed. Accepts a URL as a string, or a blob of an already loaded image file.
         * @param options Options for converting the resource provided.
         * @param success A callback function on success with the converted resource passed to it. Omitting the success and failure callbacks will automatically setup a Promise instead
         * @param failure A callback function on failure, which has the error message passed to it as a string. Omitting the success and failure callbacks will automatically setup a Promise instead
         * @returns If no callback functions are supplied, returns a Promise object that returns the converted resource. Otherwise returns nothing.
         */
        this.getConvertedResource = function (resource, options, success, failure) {
            if (!success && !failure)
                return new Promise(function (b, f) {
                    this.getConvertedResource(resource, options, b, f);
                });
            // added as it was a convention to call both or none, but broke type safety
            if (!success || !failure) {
                throw new Error('called with missing only one of success or failure handlers');
            }
            _this.getConfigurationRetrieveIfNeeded().then(function (b) {
                options.action = "return";
                BrowserPrint.convert(resource, this.device, options, success, failure);
            }).catch(failure);
        };
        /**
         * Retrieves the resource and converts it into a storeable form, storing it on the printer. The path the resource was stored at on the printer will be passed to the success function as a string.
         * @param resource The resource to be stored. Accepts a URL as a string, or a blob of an already loaded image file.
         * @param options (optional in original jsdoc) Options for converting the provided resource.
         * @param success (optional in original jsdoc) A callback function on success with the storage location path passed to it. Omitting the success and failure callbacks will automatically setup a Promise instead
         * @param failure A callback function on failure, which has the error message passed to it as a string. Omitting the success and failure callbacks will automatically setup a Promise instead
         * @returns If no callback functions are supplied, returns a Promise object that returns the storage location path. Otherwise returns nothing.
         */
        this.storeConvertedResource = function (resource, options, success, failure) {
            if (!success && !failure) {
                return new Promise(function (resolve, reject) {
                    _this.storeConvertedResource(resource, options, resolve /* NOTE: this is not a good cast */, reject);
                });
            }
            _this.getConfigurationRetrieveIfNeeded().then(function (b) {
                options.action = "store";
                BrowserPrint.convert(resource, this.device, options, success, failure);
            }).catch(failure);
        };
        this.getConfigurationRetrieveIfNeeded = function () {
            return new Promise(function (resolve, reject) {
                if (_this.configuration) {
                    resolve(_this.configuration);
                }
                else {
                    return _this.getConfiguration()
                        .then(function (configuration) {
                        _this.configuration = configuration;
                        return _this.configuration;
                    }).catch(function (err) {
                        // reject?
                        reject(err);
                    });
                }
            });
        };
        /**
         * @hidden
         */
        this.configTimeout = function (retries) {
            if (retries === undefined) {
                _this._configRetries = 0;
            }
            _this.configuration || _this.getConfiguration().then(function (configuration) {
                return _this.configuration = configuration;
            }).catch(function (err) {
                _this._configRetries++;
                console.error(err);
                if (_this._configRetries < 5) {
                    setTimeout(function () { return _this.configTimeout(_this._configRetries); }, 1000);
                }
            });
        };
        this._device = device;
        this.configuration = undefined;
        this.device_request_queue = [];
        // retrieves the config automatically as part of construction - this fails horribly anyway
        // this.configTimeout()
    }
    Object.defineProperty(Printer.prototype, "device", {
        get: function () {
            return this._device;
        },
        enumerable: false,
        configurable: true
    });
    return Printer;
}());

export { ApplicationConfiguration, BrowserPrint, Configuration, Device, Info, Printer, Status, ToFormat, BrowserPrint as default };
